module.exports = __webpack_public_path__ + "img/accessibility_jp.616d530.jpg";